import styled from 'styled-components';
import { Dialog } from 'components';

export const StyledMessage = styled.div`
  color: rgba(0, 0, 0, 0.7);
  font-weight: 500;
`;

export const StyledDialogMessage = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
`;

export const StyledDialog = styled(Dialog)`
  width: 40%;
`;

export const StyledToast = styled.div`
  width: 55%;
  margin-left: auto;
  padding: 0.5em 0 0.5em 0;
`;

export const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledCheckbox = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;
